import { changeControlEn } from './change-control-en';

export const changeControlTr = {
  ...changeControlEn,
  title: 'Değişiklik yönetimi',
  subtitle:
    'Modüller arası etkileri değerlendirin, incelemeleri yönetin ve kontrollü revizyonlar oluşturun.',
  help: 'Değişiklik yönetimi yardımını aç',
  tabs: { requests: 'Değişiklik talepleri', customerApprovals: 'Müşteri onayları' },
  actions: {
    new: 'Yeni değişiklik talebi',
    analyze: 'Etkileri analiz et',
    submit: 'İncelemeye gönder',
    reviewed: 'İncelemeyi tamamla',
    'changes-requested': 'Düzeltme iste',
    approve: 'Onayla',
    reject: 'Reddet',
    'start-implementation': 'Uygulamayı başlat',
    complete: 'Uygulamayı tamamla',
    cancel: 'Talebi iptal et',
    archive: 'Arşivle',
  },
  filters: {
    search: 'Numara, başlık, kaynak veya ürün ara',
    allStatuses: 'Tüm durumlar',
    allRisks: 'Tüm risk seviyeleri',
    allSources: 'Tüm kaynak türleri',
  },
  columns: {
    number: 'Numara',
    title: 'Başlık',
    source: 'Kaynak',
    status: 'Durum',
    risk: 'Risk',
    responsible: 'Sorumlu',
    impact: 'Etkilenen nesneler',
    updated: 'Güncellendi',
    actions: 'İşlemler',
  },
  statuses: {
    DRAFT: 'Taslak',
    IN_REVIEW: 'İncelemede',
    CHANGES_REQUESTED: 'Düzeltme gerekli',
    REVIEWED: 'İncelendi',
    APPROVED: 'Onaylandı',
    IMPLEMENTING: 'Uygulanıyor',
    IMPLEMENTED: 'Uygulandı',
    REJECTED: 'Reddedildi',
    CANCELLED: 'İptal edildi',
    ARCHIVED: 'Arşivlendi',
  },
  risks: { LOW: 'Düşük', MEDIUM: 'Orta', HIGH: 'Yüksek', CRITICAL: 'Kritik' },
  sourceTypes: {
    PRODUCT: 'Ürün / malzeme',
    MATERIAL_PROFILE: 'Malzeme profili',
    SUPPLIER_SPECIFICATION: 'Tedarikçi spesifikasyonu',
    RECIPE: 'Reçete / BOM',
    DECLARATION: 'Beyan',
    ANALYSIS_PROFILE: 'Analiz / besin',
    PROCESS_ROUTING: 'Proses rotası',
    PACKAGING: 'Ambalaj',
  },
  assigneeRoles: {
    RESPONSIBLE: 'Sorumlu',
    REVIEWER: 'İnceleyen',
    APPROVER: 'Onaylayan',
    OBSERVER: 'Gözlemci',
  },
  taskStatuses: {
    OPEN: 'Açık',
    IN_PROGRESS: 'Devam ediyor',
    COMPLETED: 'Tamamlandı',
    CANCELLED: 'İptal edildi',
  },
  decisions: {
    SUBMITTED: 'Gönderildi',
    REVIEWED: 'İncelendi',
    CHANGES_REQUESTED: 'Düzeltme istendi',
    APPROVED: 'Onaylandı',
    REJECTED: 'Reddedildi',
    IMPLEMENTING: 'Uygulama başladı',
    IMPLEMENTED: 'Uygulandı',
    CANCELLED: 'İptal edildi',
    ARCHIVED: 'Arşivlendi',
  },
  nodeTypes: {
    SOURCE: 'Değişiklik kaynağı',
    RECIPE: 'Reçeteler / BOM’lar',
    PRODUCT: 'Ürünler',
    PRODUCTION_ORDER: 'Üretim emirleri',
    PRODUCTION_PLAN: 'Üretim planlaması',
    DECLARATION: 'Beyanlar',
    SPECIFICATION: 'Ürün spesifikasyonları',
    LABEL_TEMPLATE: 'Etiket şablonları',
    CUSTOMER_APPROVAL: 'Müşteri onayları',
    SALES_ORDER: 'Açık satış siparişleri',
    PROCESS_ROUTING: 'Proses rotaları',
    ANALYSIS_PROFILE: 'Analiz profilleri',
    PACKAGING: 'Ambalajlar',
  },
  draftTargetTypes: {
    RECIPE: 'Reçete / BOM',
    PROCESS_ROUTING: 'Proses rotası',
    DECLARATION: 'Beyan',
    ANALYSIS_PROFILE: 'Analiz profili',
    SPECIFICATION: 'Ürün spesifikasyonu',
    LABEL_TEMPLATE: 'Etiket şablonu',
  },
  draftStatuses: {
    PROCESSING: 'Oluşturuluyor',
    CREATED: 'Revizyon oluşturuldu',
    FAILED: 'Oluşturma başarısız',
  },
  form: {
    newTitle: 'Değişiklik talebi oluştur',
    newDescription: 'Kaynağı, hedef durumu, riski ve bağımsız sorumlulukları kaydedin.',
    editTitle: 'Değişiklik talebini düzenle',
    editDescription: 'Yalnızca taslaklar ve iade edilen talepler düzenlenebilir.',
    title: 'Başlık',
    reason: 'Gerekçe',
    sourceType: 'Kaynak türü',
    source: 'Kaynak nesne',
    sourceVersion: 'Kaynak sürüm',
    sourceSearch: 'Kaynak ara',
    sourceSearchPlaceholder: 'Numara, ad, tedarikçi veya alan',
    selectSource: 'Kontrollü kaynak seçin',
    noSources: 'Eşleşen kaynak bulunamadı.',
    noVersion: 'Ayrı sürümü olmayan ana veri',
    sourceIdPlaceholder: 'Kaynak nesnenin kimliği',
    optionalId: 'İsteğe bağlı sürüm kimliği',
    selectProduct: 'Ürün seçin',
    risk: 'Risk seviyesi',
    riskAssessment: 'Risk değerlendirmesi',
    before: 'Önce',
    after: 'Sonra',
    requestedEffectiveDate: 'İstenen yürürlük tarihi',
    effectiveDate: 'Yürürlük tarihi',
    dueDate: 'Son tarih',
    responsibleId: 'Sorumlu kişi',
    reviewerId: 'İnceleyen',
    approverId: 'Onaylayan',
    selectUser: 'Kullanıcı seçin',
    note: 'Gerekçeli not',
  },
  messages: {
    invalidJson: 'Önce ve sonra değerlerinin her biri geçerli bir JSON nesnesi olmalıdır.',
    invalidForm: 'Tüm zorunlu alanları geçerli değerlerle doldurun.',
    noteRequired: 'En az üç karakterlik gerekçeli bir not girin.',
    created: '{{number}} numaralı talep oluşturuldu.',
    saved: 'Değişiklikler kaydedildi.',
    analyzed: 'Etki analizi kaydedildi.',
    notFound: 'Değişiklik talebi bulunamadı.',
    workflow: {
      submit: 'İncelemeye gönderildi.',
      reviewed: 'İnceleme tamamlandı.',
      'changes-requested': 'Düzeltme istendi.',
      approve: 'Talep onaylandı.',
      reject: 'Talep reddedildi.',
      'start-implementation': 'Uygulama başlatıldı.',
      complete: 'Uygulama tamamlandı.',
      cancel: 'Talep iptal edildi.',
      archive: 'Talep arşivlendi.',
    },
  },
  sections: {
    overview: 'Genel bakış',
    request: 'Talep ve risk',
    assignees: 'Sorumluluklar',
    diff: 'Önce / sonra',
    impact: 'Etki grafiği',
    tasks: 'Görevler',
    drafts: 'Kontrollü revizyonlar',
    documents: 'Belgeler',
    audit: 'İnceleme ve denetim geçmişi',
  },
  diff: {
    beforeDescription: 'Taleple kaydedilen değiştirilemez başlangıç durumu.',
    afterDescription: 'İncelenecek ve onaylanacak hedef durum.',
  },
  impact: {
    warnings: 'Etki analizi uyarıları',
    relations: 'İlişkiler',
    noRelations: 'Hiçbir ilişki belirlenmedi.',
    openNode: '{{label}} aç',
    requiredTitle: 'Güncel etki analizi gerekli',
    requiredDescription: 'Göndermeden önce etkilenen tüm nesneleri analiz edip kaydedin.',
    notAnalyzed: 'Güncel bir etki analizi yok.',
    version: 'Etki anlık görüntüsü v{{version}}, {{date}} tarihinde oluşturuldu',
  },
  impactWarnings: {
    SUPPLIER_SOURCE_NOT_VERSIONED:
      'Tedarikçi bilgisinin ayrı sürümü yoktur; değişiklik kaydı önce/sonra değerlerini sabitler.',
    PACKAGING_SOURCE_NOT_VERSIONED:
      'Ambalaj ana verisinin ayrı sürümü yoktur; değişiklik kaydı önce/sonra değerlerini sabitler.',
    BOM_TRAVERSAL_DEPTH_REACHED: 'BOM taraması en fazla 50 derinliğe ulaştı.',
    NO_DEPENDENCIES: 'Bu kaynak için bağımlı nesne bulunamadı.',
  },
  tasks: {
    new: 'Görev ekle',
    description: 'Somut bir faaliyet, sorumlu ve son tarih atayın.',
    created: 'Görev oluşturuldu.',
    completedInUi: 'Değişiklik iş akışında tamamlandı.',
    complete: 'Tamamla',
    reopen: 'Yeniden aç',
    columns: { status: 'Durum', task: 'Görev', assignee: 'Atanan kişi', due: 'Son tarih' },
    form: { description: 'Açıklama' },
  },
  drafts: {
    title: 'Yayımlanmış sürümler değişmeden kalır',
    description:
      'Etkilenen her onaylı sürüm için kontrollü yeni bir taslak veya revizyon oluşturun. Yayımlanmış belgelerin üzerine yazılmaz.',
    pending: 'Henüz revizyon oluşturulmadı',
    create: 'Revizyon oluştur',
    created: 'Kontrollü bir taslak veya revizyon oluşturuldu.',
  },
  workflow: {
    submit: {
      title: 'Talebi gönder',
      description: 'Etki anlık görüntüsü bağımsız inceleme için sabitlenir.',
    },
    reviewed: {
      title: 'İncelemeyi tamamla',
      description: 'Etki, risk ve hedef durumun kontrol edildiğini doğrulayın.',
    },
    'changes-requested': {
      title: 'Düzeltme iste',
      description: 'Düzeltilmesi gerekenleri açıkça belirtin.',
    },
    approve: {
      title: 'Talebi onayla',
      description: 'Yürürlük tarihini belirleyin ve bağımsız onay notu girin.',
    },
    reject: {
      title: 'Talebi reddet',
      description: 'Talebin neden uygulanmaması gerektiğini kaydedin.',
    },
    'start-implementation': {
      title: 'Uygulamayı başlat',
      description: 'Görevler ve kontrollü revizyonlar artık tamamlanabilir.',
    },
    complete: {
      title: 'Uygulamayı tamamla',
      description: 'Tüm görevler ve gerekli revizyonlar tamamlanmış olmalıdır.',
    },
    cancel: {
      title: 'Talebi iptal et',
      description: 'İptal denetlenir ve yayımlanmış belgeleri değiştirmez.',
    },
    archive: {
      title: 'Talebi arşivle',
      description: 'Tamamlanan kayıt ve kanıtları değiştirilemez kalır.',
    },
  },
  empty: {
    requests: 'Filtrelerle eşleşen talep yok.',
    approvals: 'Müşteri onayı yok.',
    tasks: 'Görev eklenmedi.',
    drafts: 'Sonraki revizyon gerektiren onaylı bir sürüm yok.',
    audit: 'İş akışı kararı kaydedilmedi.',
  },
  taskCount: '{{count}} açık görev',
  pagination: 'Sayfa {{page}} / {{pages}} · {{total}} talep',
  customer: {
    actions: { new: 'Yeni müşteri onayı', approve: 'Onayla', revoke: 'Geri çek' },
    columns: {
      reference: 'Referans',
      customer: 'Müşteri',
      product: 'Ürün',
      scope: 'Onay kapsamı',
      validity: 'Geçerlilik',
    },
    statuses: {
      DRAFT: 'Taslak',
      APPROVED: 'Onaylandı',
      EXPIRED: 'Süresi doldu',
      REVOKED: 'Geri çekildi',
    },
    form: {
      title: 'Müşteri onayı kaydet',
      description:
        'Onaylanan veriler karma korumalı anlık görüntü olarak saklanır ve bağımsız onay gerektirir.',
      selectCustomer: 'Müşteri seçin',
      snapshot: 'Onaylanan veri anlık görüntüsü (JSON)',
      validFrom: 'Başlangıç',
      validTo: 'Bitiş',
    },
    dialog: {
      approve: 'Müşteri onayını onayla',
      revoke: 'Müşteri onayını geri çek',
      description: 'Karar ve gerekçe denetim izine yazılır.',
    },
    messages: {
      created: 'Müşteri onayı oluşturuldu.',
      approved: 'Müşteri onayı onaylandı.',
      revoked: 'Müşteri onayı geri çekildi.',
    },
  },
} as const;
